// Copyright © 2021 Move Closer

import { Component, Prop, Vue } from 'vue-property-decorator'

import { BootstrapBadge, BootstrapIcon, BootstrapLink, Link } from '../../../dsl/front'

import { ContentSneakPeakData, ListConfig } from '../../_contracts'
import { MergedListItem } from '../ui/ListWithAddonsMixin'

import { PublicationDate } from '../PublicationDate'
import { ReadMoreLink } from '../ReadMoreLink'
import { ReadingTime } from '../ReadingTime'
import { TextListItem } from '../TextListItem/TextListItem'

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
@Component({
  name: 'TextList',
  components: { BootstrapBadge, BootstrapIcon, BootstrapLink, PublicationDate, ReadMoreLink, ReadingTime, TextListItem },

  template: `
    <div v-if="articles && articles.length" class="text-list">
      <div class="text-list__container" :class="{ '--with-read-more' : readMoreLink }">
        <!-- Articles list -->
        <ul class="text-list__list list-unstyled">
          <TextListItem
            v-for="item in articleItems"
            :key="item.key"
            :item="item"
            :list-config="listConfig"
            :without-badge="withoutBadge"
            :show-publication-date="showPublicationDate"
            :show-reading-time="showReadingTime" />
        </ul>
        <!-- END | Articles list -->
      </div>

      <!-- "Read more" button -->
      <div v-if="readMoreLink" class="text-list__read-more-link">
        <ReadMoreLink :link="readMoreLink" />
      </div>
    </div>
  `
})
export class TextList extends Vue {
  /**
   * Articles to be rendered.
   */
  @Prop({ type: Array, required: true })
  public readonly articles!: ContentSneakPeakData[]

  /**
   * "Read more" link.
   */
  @Prop({ type: Object, required: false })
  public readonly readMoreLink?: Link

  @Prop({ type: Boolean, default: false })
  public readonly withoutBadge!: boolean

  @Prop({ type: Boolean, default: false })
  public readonly showPublicationDate!: boolean

  @Prop({ type: Boolean, default: false })
  public readonly showReadingTime!: boolean

  /**
   * ArticlesList Config.
   */
  @Prop({ type: Object, required: false, default: () => { return { showArticleTags: false } } })
  public readonly listConfig?: ListConfig

  /**
   * Converts articles to MergedListItem format for TextListItem
   */
  public get articleItems (): MergedListItem[] {
    return this.articles.map((article, index) => ({
      type: 'article' as const,
      component: '',
      data: article,
      props: {},
      position: index,
      key: `article-${article.id || index}`
    }))
  }

  public get showBadge (): boolean {
    if (!this.listConfig) {
      return false
    }

    if (typeof this.listConfig.showArticleTags === 'undefined') {
      return false
    }
    return this.listConfig.showArticleTags
  }
}
